import Timeline from "./Timeline.js";
import TimelineVideo from "./TimelineVideo.js";
export default class Header {
  /*
   * Fires first
   */
  constructor() {

    this.$modal = $('.js--modal'); 

    // Add events
    this.addEvents();
  }

  /*
   * Add events
   */
  addEvents() {
    $('.js--modal-video').on('click', e => {
      e.preventDefault();

      let video_url = e.currentTarget.href; 
      this.openModal(video_url);
    })

    $('.js--modal-close').on('click', () => {
      this.closeModal();
    });
  }

  openModal(video_url) {

    this.$modal.find('.js--modal-content').html(`<video class="js--modal-video // w-full" controls src="${video_url}"></video>`);

    this.$modal.find('.js--modal-video')[0].play();  

    
    $("video:not(.ignore-tracking)").each(function () {
      var video = this;
      $(video)
          .addClass("ignore-tracking")
          .data(
              "timeline-video",
              new TimelineVideo([25, 50, 75, 100], video)
          ); 
    });
        

    this.$modal.css("display", "flex")
      .hide()
      .fadeIn();
  }

  closeModal() {
    this.$modal.find('.js--modal-video')[0].pause();
    this.$modal.fadeOut();
  }
}
